import { isset } from "@cawita/core-front";
import { Profile } from "@shared/models";

function profileHasInterests(profile?: Profile) { return (profile?.interests?.length ?? 0) > 0; }
function profileHasLanguages(profile?: Profile) { return (profile?.languages?.length ?? 0) > 0; }
function profileHasCampingType(profile?: Profile) { return isset(profile?.campingType); }
function profileHasBirthDate(profile?: Profile) { return isset(profile?.birthDate); }

const InterestsWeight = 80;
const LanguagesWeight = 5;
const CampingTypeWeight = 10;
const BirthDateWeight = 5;

export function profileCompletionPercent(profile?: Profile) {
    let totalPercent = 0;
    if (profileHasInterests(profile)) totalPercent += InterestsWeight;
    if (profileHasLanguages(profile)) totalPercent += LanguagesWeight;
    if (profileHasCampingType(profile)) totalPercent += CampingTypeWeight;
    if (profileHasBirthDate(profile)) totalPercent += BirthDateWeight;
    return totalPercent;
}

    // if (!hasNoInterest(profile)) qtyOfInfoSupplied += 1;
    // if (!hasNoLanguage(profile)) qtyOfInfoSupplied += 1;
    // if (!hasNoCampingType(profile)) qtyOfInfoSupplied += 1;
    // if (!hasNoBirthDate(profile)) qtyOfInfoSupplied += 1;